module.exports = __webpack_public_path__ + "img/img_detail1_mobile.663b558f.png";